import React, { useState } from 'react'
import Checkbox from "@material-ui/core/Checkbox";

function SimpleCheckbox() {
  const [checks, setChecks] = useState({
    checkBoxA: true,
    checkBoxB: true,
    checkBoxC: true,
  });
  const handleChange = (box) => (event) => {
    setChecks({ ...checks, [box]: event.target.checked })
  }
  return (
    <div>
      <Checkbox
        checked={checks.checkBoxA}
        onChange={handleChange("checkBoxA")}
        value="checkBoxA"
        inputProps={{
          "aria-label": "primary checkbox"
        }}
      />
      <Checkbox
        checked={checks.checkBoxB}
        onChange={handleChange("checkBoxB")}
        value="checkBoxB"
        color="primary"
        inputProps={{
          "aria-label": "secondary checkbox"
        }}
      />
      <Checkbox
        value="checkedC"
        inputProps={{
          "aria-label": "uncontrolled-checkbox"
        }}
      />
      <Checkbox
        disabled
        value="checkedD"
        inputProps={{
          "aria-label": "disabled checkbox"
        }}
      />
      <Checkbox
        disabled
        checked
        value="checkedE"
        inputProps={{
          "aria-label": "disabled checked checkbox"
        }}
      />
      <Checkbox
        checked={checks.checkBoxC}
        onChange={handleChange("checkBoxC")}
        value="checkBoxC"
        indeterminate
        inputProps={{
          "aria-label": "indeterminate checkbox"
        }}
      />
      <Checkbox
        defaultChecked
        color="default"
        value="checkedG"
        inputProps={{
          "aria-label": "checkbox with default color"
        }}
      />
    </div>
  )
}

export default SimpleCheckbox
